/* eslint-disable import/prefer-default-export */
import organizationRoles from '@airtm/utils/dist/constants/organizationRoles';

const { ADMIN, INITIATOR, APPROVER, AUDITOR, OWNER } = organizationRoles;

type OrganizationPermissions = {
  canDeleteAdmins: boolean;
  canInviteAdmins: boolean;
  canCreateSinglePayment: boolean;
  canCreateBulkPayment: boolean;
  canCancelBulkPayment: boolean;
  canApproveBulkPayment: boolean;
  canViewAllSettingsTabs: boolean;
  canAddFunds: boolean;
  canAccessWithdraw: boolean;
  canAccessAirners: boolean;
};

const ALL_PERMISSIONS: OrganizationPermissions = {
  canDeleteAdmins: true,
  canInviteAdmins: true,
  canCreateSinglePayment: true,
  canCreateBulkPayment: true,
  canCancelBulkPayment: true,
  canApproveBulkPayment: true,
  canViewAllSettingsTabs: true,
  canAddFunds: true,
  canAccessWithdraw: true,
  canAccessAirners: true,
};

const ROLE_PERMISSION_OVERRIDES: Record<string, Partial<OrganizationPermissions>> = {
  [OWNER]: {},

  [ADMIN]: {
    canDeleteAdmins: false,
    canInviteAdmins: false,
  },

  [INITIATOR]: {
    canDeleteAdmins: false,
    canInviteAdmins: false,
    canCreateSinglePayment: false,
    canCancelBulkPayment: false,
    canApproveBulkPayment: false,
    canAddFunds: false,
    canAccessWithdraw: false,
    canAccessAirners: false,
    canViewAllSettingsTabs: false,
  },

  [APPROVER]: {
    canDeleteAdmins: false,
    canInviteAdmins: false,
    canCreateSinglePayment: false,
    canCreateBulkPayment: false,
    canAddFunds: false,
    canAccessWithdraw: false,
    canAccessAirners: false,
    canViewAllSettingsTabs: false,
  },

  [AUDITOR]: {
    canDeleteAdmins: false,
    canInviteAdmins: false,
    canCreateSinglePayment: false,
    canCreateBulkPayment: false,
    canCancelBulkPayment: false,
    canApproveBulkPayment: false,
    canAddFunds: false,
    canAccessWithdraw: false,
    canAccessAirners: false,
    canViewAllSettingsTabs: false,
  },
};

export const getOrganizationPermissions = (role: string) => {
  const overrides = ROLE_PERMISSION_OVERRIDES[role] ?? {};

  return {
    ...ALL_PERMISSIONS,
    ...overrides,
    __typename: 'Local__OrganizationPermissions',
  };
};
